import { Input } from "@/components/ui/input";

interface PlanNameInputProps {
  name: string;
  onChange: (value: string) => void;
}

export const PlanNameInput = ({ name, onChange }: PlanNameInputProps) => {
  return (
    <Input
      placeholder="Nombre del plan de entrenamiento"
      value={name}
      onChange={(e) => onChange(e.target.value)}
      className="bg-white/10 border-white/20 text-white placeholder:text-white/50 flex-1"
    />
  );
};